<avi-repeated-strings
    [name]="name"
    [placeholder]="placeholder"
    objectType="{{ objectType }}"
    fieldName="{{ fieldName }}"
    [allowDuplicates]="allowDuplicates"
    [minLimit]="minLimit"
    [maxLimit]="maxLimit"
    [(ngModel)]="repeatedStringsModel"
    (ngModelChange)="handleUpdate()"
    required
></avi-repeated-strings>
